import { MARQUEE_ITEMS } from "./data";

function Row({ hidden }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display italic text-2xl md:text-4xl text-bone/70 px-8 md:px-12 whitespace-nowrap">
            {item}
          </span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold/70" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-obsidian py-6 md:py-8">
      <div data-testid="marquee-track" className="marquee-track flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
